<template>
  <div>
    <p v-if="added.typeSpecific.nextEvent.strikeHit">
      Bei einem unveränderten Basiswertkurs kommt es zu einer (vorzeitigen)
      Rückzahlung zum Nennbetrag von <span
      v-html="this.$options.filters.currency(product.specific.notional, 'EUR')"></span>
      zuzüglich einer Zahlung eines Bonusbetrages in Höhe von <span
      v-html="this.$options.filters.percent(added.typeSpecific.nextEvent.savings + added.typeSpecific.nextEvent.payoff)"></span>
      am <span v-html="this.$options.filters.date(added.typeSpecific.nextEvent.couponPayDate)"></span>.
    </p>

    <p v-if="!added.typeSpecific.nextEvent.strikeHit && !added.typeSpecific.nextEvent.memoryHit">
      Bei einem unveränderten Basiswertkurs kommt es zu keiner vorzeitigen Rückzahlung. Die nächste Chance auf Zahlung
      eines
      Bonusbetrages in Höhe von <span
      v-html="this.$options.filters.percent(added.typeSpecific.nextEvent.savings + added.typeSpecific.nextEvent.payoff)"></span>
      erfolgt am <span v-html="this.$options.filters.date(added.typeSpecific.nextEvent.couponPayDate)"></span>.
    </p>

    <p v-if="added.typeSpecific.nextEvent.memoryHit && added.physical">
      Bei einem unveränderten Basiswertkurs erhält der Anleger am Ende der Laufzeit eine Lieferung von
      Aktien des Basiswertes. Die Anzahl der zu liefernden Aktien ergibt sich durch das Bezugsverhältnis. Bruchteile
      von Aktien werden in bar zurückgezahlt (Ausgleichszahlung).
    </p>

    <p v-if="added.typeSpecific.nextEvent.memoryHit && !added.physical">
      Bei einem unveränderten Basiswertkurs erfolgt die Rückzahlung zum Kurs des Basiswertes am
      Bewertungstag, multipliziert mit dem Bezugsverhältnis. In diesem Fall treten Verluste für das eingesetzte
      Kapital auf.
    </p>
  </div>
</template>

<script>
export default {
  name: 'payback-memory-express',
  props: {
    product: {
      type: Object,
      required: true
    },
    added: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaybackBonusExpress.vue?d07961d0